import { AstraParagraph } from '~/astra'

type Props = {
    colors: readonly string[]
    selectedColor: string
    onColorChange: (color: string) => void
}

export const ColorPicker = ({ colors, selectedColor, onColorChange }: Props) => (
    <div className="flex flex-col gap-2">
        <AstraParagraph variant="body-large" weight="medium">
            Velg farge
        </AstraParagraph>

        <div className="flex flex-wrap gap-3">
            {colors.map(color => (
                <button
                    key={color}
                    type="button"
                    onClick={() => onColorChange(color)}
                    className={`size-7 rounded-full border transition-all ${selectedColor === color ? 'border-2 border-ring p-[2px]' : 'border-transparent'}`}
                    aria-label={`Velg farge ${color}`}
                >
                    <span className="block size-full rounded-full" style={{ backgroundColor: color }} />
                </button>
            ))}
        </div>
    </div>
)
